module.exports = __webpack_public_path__ + "img/img1.b3509cf1.jpg";